
import { Options, Vue, prop } from "vue-class-component";
import ModalV2 from "@/app/ui/components/modal-v2/index.vue";
import LpButton from "@/app/ui/components/lp-button/index.vue";

class Props {
  isOpen = prop<boolean>({
    required: true,
    type: Boolean
  });
}

@Options({
  emits: ["confirm", "cancel"],
  components: {
    ModalV2,
    LpButton
  }
})
export default class ModalActivePickupWarning extends Vue.with(Props) {
  onConfirm() {
    this.$emit("confirm");
  }

  onCancel() {
    this.$emit("cancel");
  }
}
